import { environment } from "../../environments/environment";

export const Constants = {
	ApiUrl: environment.ApiUrl,
	ApiUrlV2: environment.ApiUrl.replace('/api/v1/', '/api/v2/'),
	ApiUrlReporting: environment.ApiUrlReporting,

	EmptyGuid: '00000000-0000-0000-0000-000000000000',
	SearchEmptyGuid: 'ffffffff-ffff-ffff-ffff-ffffffffffff',
	NoImageUrl: '/assets/image/placeholder-image.png',
	PlaceholderImageUrl: '/assets/image/placeholder-halfway.png',
	PlaceholderCarUrl: '/assets/image/placeholder-car.png',
	PlaceholderContactUrl: '/assets/image/placeholder-contact.png',
	PlaceholderPosterUrl: '/assets/image/placeholder-poster-thumb.png',

    DateFormatShort: 'dd MMM yyyy',
    DateFormatShortISO: 'yyyy-MM-dd',
    DateTimeFormatShort: 'dd MMM yyyy h:mm a',

	DateMinimum: '1900-01-01',
	DateMaximum: '2999-12-31',

	LocalStorage_AccessToken: 'AccessToken',
	LocalStorage_RefreshToken: 'RefreshToken',
	LocalStorage_OverrideClientID: 'OverrideClientID',

	LocalStorage_LoggedIn: 'loggedin',
	LocalStorage_BiometricID: 'biometricid',

	LocalStorage_MCUserId: 'motorcentral-user-id',
	LocalStorage_MCDealershipId: 'motorcentral-dealership-id',
	LocalStorage_MCUsername: 'motorcentral-username',
	LocalStorage_MCCustomerNumber: 'motorcentral-customerNumber',
	LocalStorage_MCDesktopVersion: 'motorcentral-version',
	LocalStorage_MCNotificationDeviceToken: 'motorcentral-notification-device-token',
	LocalStorage_DashboardOverview_Parameters: 'dashboard-overview-parameters',


	LocalStorage_LicenceScannerSkipTips: 'licence-scanner-skip-tips',
	LocalStorage_Updates: 'updates',
	LocalStorage_UpdatePrompted: 'update_prompted',
	LocalStorage_RecentVehiclesInitialised: 'recent-vehicles-initialised',
	LocalStorage_WholesaleRecentVehiclesInitialised: 'wholesale-recent-vehicles-initialised',
	LocalStorage_ClientsideAuthExpiry: 'ClientsideAuthExpiry',

	IonicStorage_CustomerNumber: 'customerNumber',
	IonicStorage_Username: 'username',
	IonicStorage_Initials: 'initials',
	IonicStorage_Name: 'name',
	IonicStorage_Theme: 'mc-theme',

	IonicStorage_RecentVehicles: 'recent-vehicles',
	IonicStorage_VehicleListSort: 'vehicle-list-sort',
	IonicStorage_VehiclesPopularSearches: 'vehicles-popular-searches',
	IonicStorage_VehiclesRecentSearches: 'vehicles-recent-searches',

	IonicStorage_RecentContacts: 'recent-contacts',
	IonicStorage_SearchRecentContacts: 'recent-search-contacts',
	IonicStorage_ContactListSort: 'contact-list-sort',
	IonicStorage_ContactsPopularSearches: 'contacts-popular-searches',
	IonicStorage_ContactRecentSearches: 'contacts-recent-searches',

	IonicStorage_RecentOpportunities: 'recent-opportunities',
	IonicStorage_OpportunityListSort: 'opportunity-list-sort',
	IonicStorage_OpportunitiesPopularSearches: 'opportunities-popular-searches',
	IonicStorage_OpportunitiesRecentSearches: 'opportunities-recent-searches',

	IonicStorage_RecentSales: 'recent-sales',
	IonicStorage_SaleListSort: 'sale-list-sort',
	IonicStorage_SalesPopularSearches: 'sales-popular-searches',
	IonicStorage_SalesRecentSearches: 'sales-recent-searches',

	IonicStorage_CarCheckRecentSearches: 'carcheck-recent-searches',

	IonicStorage_WholesaleRecentVehicles: 'wholesale-recent-vehicles',
	IonicStorage_RecentWholesaleVehicles: 'recent-wholesale-vehicles',
	IonicStorage_WholesaleVehicleListSort: 'wholesale-vehicle-list-sort',
	IonicStorage_WholesalePopularSearches: 'wholesale-popular-searches',
	IonicStorage_WholesaleRecentSearches: 'wholesale-recent-searches',

	
	IonicStorage_WebsiteVehiclesRecent: 'website-admin-recent-vehicles',
	IonicStorage_WebsiteVehicleListSort: 'website-admin-vehicle-list-sort',
	IonicStorage_WebsiteVehiclesPopularSearches: 'website-admin-vehicles-popular-searches',
	IonicStorage_WebsiteVehiclesRecentSearches: 'website-admin-vehicles-recent-searches',

	StatusBarColor_Dark: "#212121",
	StatusBarColor_Medium: "#4c4c4c",
	StatusBarColor_Light: "#ffffff",
	StatusBarColor_Green: "#bece2b",

	LocalStorage_ResultLayout: "ResultLayoutSetting",
    
	IonicStorage_StocktakeSupplier: "StocktakeSupplier",

	Separator: " • ",

	Vehicle_Status_Unsold: '20',
	Vehicle_Status_Sold_Caption: 'Sold',
	Vehicle_Status_SoldInProgress_Caption: 'Sold (In Progress)',
	Vehicle_OnYardGuid: '5a449507-b595-477d-b25e-3b450c5cebce',

	IonicStorage_DefaultStartupApp: 'default-startup-app',
	IonicStorage_DefaultDmsStartupPage: 'default-startup-page',
    IonicStorage_DefaultWebsiteAdminStartupPage: 'default-website-admin-startup-page',
    IonicStorage_DefaultVehicleXchangeStartupPage: 'default-vehiclexchange-startup-page',
    IonicStorage_DefaultCarCheckStartupPage: 'default-carcheck-startup-page',


	IonicStorage_DashboardSaleFilters: 'dashboard-sale-filters',
	IonicStorage_DashboardSaleBreakdownFilters: 'dashboard-sale-breakdown-filters',

    ApiDefaultTimeout: 60000,
    ApiShortTimeout: 30000,
    ApiLongTimeout: 120000,

    CacheKey_Rights: 'rights',
    CacheKey_RightsExtended: 'rights-extended',

    ReportSpecId_ManagersStockList: "74DE3C51-0E8D-439A-BE1E-0B9278267295",
    ReportSpecId_SalespersonStockList: "14ACF593-C668-43B2-A2F6-BAEE57FA5A87",
    ReportSpecId_ManagersSales: "005DEB08-E479-453C-9A96-A3189C6CD8D3",
    ReportSpecId_VehicleStocktakeReport: "CA4D0051-BC8E-4973-8DE0-4F17F5369128",
    ReportSpecId_MoneyOutstanding: "10DFA843-D4D6-48ED-A05C-99446BDDB9E7",
    IonicStorage_DynamicReportSpec: 'dynamic-report-spec',
    IonicStorage_DynamicReportScheduledTaskId: 'dynamic-report-scheduled-task-id',

	IonicStorage_BulkUpdateScheduledTaskId: 'bulk-update-scheduled-task-id',
	IonicStorage_AccountingExportScheduledTaskId: 'accounting-export-scheduled-task-id',
    IonicStorage_BulkUpdateVehicleListSort: 'bulk-update-vehicle-list-sort',

};
